export interface FileDisplayNameSnapshot {
  title?: string;
  description?: string | null;
  data?: {
    name?: string;
  };
}

export function getFileDisplayName(
  file: FileDisplayNameSnapshot | undefined,
  fallback = ''
): string {
  return file?.title || file?.data?.name || file?.description || fallback;
}

export function getIssueAttachmentDisplayName(
  file: FileDisplayNameSnapshot | undefined,
  fallback = ''
): string {
  return file?.description || file?.title || file?.data?.name || fallback;
}
